module.exports = __webpack_public_path__ + "static/assets/46910ddf429e37f405045fb1d03ff375.png";